import React, { useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputPercentOfInflation = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(props.rowData);
    _.set(nextData, "inputtype", "% of Inflation");
    _.set(nextData, "increasedetail", {
      state: "% of Inflation"
    })

    if (field === 'inflationdetail.inflationNamedItemId'){
      _.set(nextData, 'inflationdetail', {inflationNamedItemId: val, inflationMode: 'namedItem'});
    } else {
      _.set(nextData, field, val);
    }

    if (!nextData['inflationdetail']) _.set(nextData, 'inflationdetail', {'inflationMode': 'namedItem', 'inflationNamedItemId': props.defaults['increaseInflation']['inflationNamedItemId']});

    if (!nextData['effectivemonth']) _.set(nextData, 'effectivemonth', 'Lease Year')

    props.persist(nextData, props.field, props.rowData)
  }

  const unnested_attrs = (field) => field_attrs('increase')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={props['rowData']['inputtype'] === '% of Inflation' && props['rowData']} attrs={unnested_attrs} field="amt" readPrecision={4} writePrecision={4} persist={updateData} style={{width: 100}} />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput
            className="automated"
            data={props['rowData']['inputtype'] === '% of Inflation' && props['rowData']}
            default={props['defaults']['increaseInflation']['inflationNamedItemId']}
            attrs={unnested_attrs}
            field="inflationdetail.inflationNamedItemId"
            namedItem="inflationNamedItemId"
            options={_.get(props, "namedItems.inflation")}
            persist={updateData}
          />
        </div>
        <div>
          <label>Effective</label>
          <DropdownInput className="automated" data={props['rowData']['inputtype'] === '% of Inflation' && props['rowData']} default="Lease Year" attrs={unnested_attrs} field="effectivemonth" options={['Calendar Year', 'Lease Year', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputPercentOfInflation